// Discovery adapter for the BROWSER (Vite). `import.meta.glob` is statically
// analysed by Vite, so every file under `src/models/**` is bundled and its raw
// source embedded — no server round-trip needed for the gallery or the
// copy-source button. This is one of the two adapters behind the registry
// seam; the Node adapter (discover.node.ts) returns the identical shape from
// the filesystem. The model files themselves are environment-agnostic.

import { modelsFromModule, relModelPath, type LoadedModel } from "./registry";

// Eagerly import every model module and, separately, its raw text.
const modules = import.meta.glob<Record<string, unknown>>("../models/**/*.ts", { eager: true });
const sources = import.meta.glob<string>("../models/**/*.ts", {
  eager: true,
  query: "?raw",
  import: "default",
});

/** Every model found in the bundle, paired with its path and source. */
export function discoverModels(): LoadedModel[] {
  const out: LoadedModel[] = [];
  for (const [path, mod] of Object.entries(modules)) {
    const source = sources[path] ?? "";
    for (const model of modelsFromModule(mod)) {
      out.push({ model, path: relModelPath(path), source });
    }
  }
  return out;
}
